// extracted by css-extract-rspack-plugin
export default {"notVerified":"NotVerified__notVerified--bVIvs","link":"NotVerified__link--Iv1NU"};